import Main from "./Component/Main";

function App() {
  return (
   <>
   <Main />
   </>
  );
}

export default App;
